import React from "react"
import styled from "styled-components"
import { FiCheckCircle } from "react-icons/fi"
import Image from "gatsby-plugin-sanity-image"
import PortableTextFull from "./PortableTextFull"
import { Link } from "gatsby"
const FullArticle = ({
  themeColor,
  title,
  category,
  subcategory,
  publishDay,
  text,
  image,
  tags,
  author,
}) => {
  var themeBgColor = "text-fb-blue"
  var themeTextColor = "text-fb-blue"

  switch (themeColor) {
    case "fb-green": {
      themeBgColor = "bg-fb-green"
      themeTextColor = "text-fb-green"
      break
    }
    case "fb-turquoise": {
      themeBgColor = "bg-fb-turquoise"
      themeTextColor = "text-fb-turquoise"
      break
    }
    case "fb-gray": {
      themeBgColor = "bg-fb-gray"
      themeTextColor = "text-fb-gray"
      break
    }
    case "fb-red": {
      themeBgColor = "bg-fb-red"
      themeTextColor = "text-fb-red"
      break
    }
    case "fb-violet": {
      themeBgColor = "bg-fb-violet"
      themeTextColor = "text-fb-violet"
      break
    }
    default: {
      themeBgColor = "bg-fb-blue"
      themeTextColor = "text-fb-blue"
      break
    }
  }
  return (
    <>
      <div className="relative h-80">
        <Image
          // pass asset, hotspot, and crop fields
          {...image}
          // tell Sanity how large to make the image (does not set any CSS)
          width={500}
          height={300}
          alt={image.alt || "Finanzas de bolsillo"}
          className="rounded"
          // style it how you want it
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        <CategoryBar className={`${themeBgColor} category-bar`}>
          {category}
        </CategoryBar>
      </div>
      {image.caption !== null && (
        <figcaption className="text-gray-600 font-roboto font-thin text-xs pl-3">
          {image.caption}
        </figcaption>
      )}

      <div className="px-3">
        <h2 className={`${themeTextColor} subheader-big-article`}>{subcategory}</h2>
        <h3 className="article-name-big-article">{title}</h3>
        <div className="flex py-2">
          <FiCheckCircle />
          <small className="pl-3">{publishDay}</small>
          <small className="px-3">&mdash;</small>
          <small className="text-fb-blue"> {author.name}</small>
        </div>
        <hr />
        <div className="p-5 flex">
          {tags.map((tag, index) => (
            <Link key={index} to={`/tags/${tag.slug.current}`}>
              <div className="bg-fb-blue hover:bg-white border border-transparent hover:border-fb-blue text-white hover:text-fb-blue text-base font-semibold font-opensanscond py-2 px-4 mr-2 rounded-full">
                {`#${tag.title}`}
              </div>
            </Link>
          ))}
        </div>
        <hr />
        <PortableTextFull textData={text} />
      </div>
      {/* <hr />
      <div className="p-5">
        {tags.map((tag, index) => (
          <Link key={index} to={`/tags/${tag.slug.current}`}>
            <span className="bg-fb-blue hover:bg-white border border-transparent hover:border-fb-blue text-white hover:text-fb-blue text-xl font-semibold font-opensanscond py-2 px-4 mr-2 rounded-full">
              {`#${tag.title}`}
            </span>
          </Link>
        ))}
      </div>
      <hr /> */}
    </>
  )
}

const CategoryBar = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 100%;
  height: 60px;
`
export default FullArticle
